// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlusCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path
                fill="#EB6D00"
                d="M5.625,8.25 L5.625,6.375 L3.75,6.375 C3.54374993,6.375 3.375,6.20624971 3.375,6 C3.375,5.79374993 3.54374993,5.625 3.75,5.625 L5.625,5.625 L5.625,3.75 C5.625,3.54375029 5.79374993,3.375 6,3.375 C6.20624971,3.375 6.375,3.54375029 6.375,3.75 L6.375,5.625 L8.25,5.625 C8.45624971,5.625 8.625,5.79374993 8.625,6 C8.625,6.20624971 8.45624971,6.375 8.25,6.375 L6.375,6.375 L6.375,8.25 C6.375,8.45624971 6.20624971,8.625 6,8.625 C5.79374993,8.625 5.625,8.45624971 5.625,8.25 Z M12,6 C12,9.31406236 9.31406236,12 6,12 C2.68593764,12 0,9.31406236 0,6 C0,2.68593764 2.68593764,0 6,0 C9.31406236,0 12,2.68593764 12,6 Z M6,0.75 C3.10078132,0.75 0.75,3.10078096 0.75,6 C0.75,8.89921904 3.10078132,11.25 6,11.25 C8.89921904,11.25 11.25,8.89921904 11.25,6 C11.25,3.10078096 8.89921904,0.75 6,0.75 Z"
            />
        </svg>
    );
};

export default React.memo(PlusCircle);
